// Golem fork (FT-1477): WHICH TOWN the backdrop shows — the moonlit town square
// (the app's standing look), a gothic cathedral square, or the Reader's cart.
//
// Built as the coin/seat-frame dress's twin (golem/coinArt, golem/seatFrame):
// the choice is published as CSS custom properties on the document root, so
// switching town is a repaint — App.vue's backdrop rules read var(--town-bg)
// (the full plate) and var(--town-bg-small) (the JPEG companion that paints
// first, see App.vue's FT-1316 two-layer note) instead of a hardcoded url. A
// LOCAL choice, this browser only, remembered per account through the `townBg`
// pref (golem/prefs owns the remembered value and calls applyTownBg on every
// prefs landing, exactly as it does applyCoin / applyFrame).
import townFull from "../assets/background-lots-town.jpg";
import townSmall from "../assets/background-lots-town-small.jpg";
import cathedralFull from "../assets/background-lots-town3.jpg";
import cathedralSmall from "../assets/background-lots-town3-small.jpg";
import cartFull from "../assets/background-lots-cart.jpg";
import cartSmall from "../assets/background-lots-cart-small.jpg";

// The backdrops a town can wear. `town` is the app's standing look and the
// default; the other two are the alternate squares. Each carries its full
// plate and the small JPEG companion App.vue paints first. Kept as a list so a
// picker can offer them the way the coin lab offers COINS.
export const TOWN_BGS = [
  { id: "town", label: "Town", full: townFull, small: townSmall },
  {
    id: "cathedral",
    label: "Cathedral",
    full: cathedralFull,
    small: cathedralSmall,
  },
  { id: "cart", label: "Cart", full: cartFull, small: cartSmall },
];

/** Paint the choice onto the root so every backdrop rule follows it. Both the
 *  full plate and its small companion ride vars so the FT-1316 progressive
 *  load survives the swap; the CSS-side fallback (the town jpgs) covers the
 *  first paint before this module runs. */
export function applyTownBg(id) {
  const pick = TOWN_BGS.find((b) => b.id === id) || TOWN_BGS[0];
  const root = document.documentElement;
  root.style.setProperty("--town-bg", `url(${pick.full})`);
  root.style.setProperty("--town-bg-small", `url(${pick.small})`);
}
